import FluxUtils from 'flux/utils';

import SettingsStore from 'sharedreact/stores/SettingsStore';
import { assertNonNullish } from 'sharedreact/utils/TypeSupport';

import UsageActions from 'workspaces/launcher/actions/UsageActions';
import UsageOptOutDialog from 'workspaces/launcher/components/admin/UsageOptOutDialog';
import asFunctional from 'sharedreact/components/asFunctional';

type Props = {
  show: boolean,
  allowRemoveData: boolean,
  onClose: () => void
};

type State = ConstructorParameters<typeof UsageOptOutDialog>[0];

function getStores () {
  return [
    SettingsStore
  ];
}

function calculateState (prevState?: State, props?: Props): State {
  assertNonNullish(props);

  return {
    language: SettingsStore.getLanguage(),
    show: props.show,
    allowRemoveData: props.allowRemoveData,
    onOptOut: UsageActions.optOut,
    onClose: props.onClose
  };
}

export default FluxUtils.Container.createFunctional(
  asFunctional(UsageOptOutDialog),
  getStores,
  calculateState,
  { withProps: true }
);
